import { boxShadow, color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  fontFamily: fonts.tvFont,
});

export const modal: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ cssProps, theme }) => ({
  zIndex: 3,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: cssProps?.showLeftBorder ? 'none' : boxShadow(theme, theme.modals.boxShadow),
  margin: 'auto',
  maxHeight: '100%',
  width: cssProps?.deleteModal ? '420px' : '640px',
  overflow: 'hidden',
  position: 'absolute',
  lineHeight: '20px',
  borderRadius: '4px',
  borderLeft: cssProps?.showLeftBorder ? `4px solid ${theme.colors.interactive.primary.default}` : 'none',
  flexDirection: 'column',
  justifyContent: 'space-between',
});
